import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {Observable} from 'rxjs';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Select, Store} from '@ngxs/store';
import {DictionaryState} from '../../../../../../state/dictionary/dictionary.state';
import {Dictionary} from '../../../../../../models/dictionary.model';
import {PartnerState} from '../../../../../../state/partner/partner.state';
import {PartnerIdentity} from '../../../../../../models/partner.model';
import {DictionaryCode} from '../../../../../../enums/dictionary-code.enum';
import {DocumentActions} from '../../../../../../state/document/document.actions';

@Component({
    selector: 'app-document-list-filters',
    templateUrl: './document-list-filters.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentListFiltersComponent {
    @Select(DictionaryState.getDictionary(DictionaryCode.PRODUCT_STATUS)) salesStatusDictionary$: Observable<Dictionary>;
    @Select(PartnerState.partnerFieldList) partners$: Observable<PartnerIdentity[]>;
    @Input() editMode = false;
    filtersForm: FormGroup;
    dictionaryCode = DictionaryCode;

    constructor(
        private formBuilder: FormBuilder,
        private store: Store,
    ) {
        this.filtersForm = formBuilder.group({
            search: [''],
            partnerId: [undefined],
            category: [undefined],
            visibility: [undefined],
        });
    }

    onSubmit() {
        if (this.filtersForm.invalid) {
            return;
        }
        this.store.dispatch(new DocumentActions.GetListPage());
    }
}
